import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import { getDayOfWeek } from './dateFormatter';

export const createObjWithUniqueFields = (arrayOfElements, fieldName = 'Date', fieldValueName = 'Impressions') => {
  const newObj = {};

  arrayOfElements.forEach(report => {
    if (newObj[report[fieldName]]) {
      newObj[report[fieldName]] = newObj[report[fieldName]] + report[fieldValueName];
    } else {
      newObj[report[fieldName]] = report[fieldValueName];
    }
  });

  return newObj;
};

const getWeightedValue = (weights, values) => {
  const weightedValues = values.map((value, i) => value * weights[i]);
  const actualValue = weightedValues.reduce((partialSum, a) => partialSum + a, 0);
  return actualValue;
};

const getCalculatedValue = (value, defaultValue = 0) => {
  return !Number.isNaN(value) || Number.isFinite(value) ? value : defaultValue;
};

export const createDayOfWeekArray = arrayOfElements => {
  const currentArray = arrayOfElements.filter(item => item.Day);
  const newObj = {};

  currentArray.forEach(element => {
    const dayNumber = getDayOfWeek(element['Day']);
    const existingField = newObj[dayNumber];
    newObj[dayNumber] = existingField
      ? {
          Impressions: [...existingField.Impressions, element.Impressions],
          totalImpressions: existingField.totalImpressions + element.Impressions,
          Frequency: [...existingField.Frequency, element.Frequency],
          Clicks: existingField.Clicks + element.Clicks,
          [BeeswaxReportProperties.IP_CONVERSIONS]:
            existingField[BeeswaxReportProperties.IP_CONVERSIONS] + element[BeeswaxReportProperties.IP_CONVERSIONS],
          [BeeswaxReportProperties.VIDEO_PLAYS]:
            existingField[BeeswaxReportProperties.VIDEO_PLAYS] + element[BeeswaxReportProperties.VIDEO_PLAYS],
          [BeeswaxReportProperties.VIDEO_COMPLETES]:
            existingField[BeeswaxReportProperties.VIDEO_COMPLETES] + element[BeeswaxReportProperties.VIDEO_COMPLETES],
          LTR: [...existingField.LTR, element.LTR],
        }
      : {
          Impressions: [element.Impressions],
          totalImpressions: element.Impressions,
          Frequency: [element.Frequency],
          Clicks: element.Clicks,
          [BeeswaxReportProperties.IP_CONVERSIONS]: element[BeeswaxReportProperties.IP_CONVERSIONS],
          [BeeswaxReportProperties.VIDEO_PLAYS]: element[BeeswaxReportProperties.VIDEO_PLAYS],
          [BeeswaxReportProperties.VIDEO_COMPLETES]: element[BeeswaxReportProperties.VIDEO_COMPLETES],
          LTR: [element.LTR],
        };
  });

  const processedResultArray = [];
  for (const [key, value] of Object.entries(newObj)) {
    const { Impressions, totalImpressions, Frequency, Clicks, LTR } = value;
    const impressionWeights = Impressions.map(impression => getCalculatedValue(impression / totalImpressions));

    const actualFrequency = getWeightedValue(impressionWeights, Frequency);
    const actualReach = Math.round(getCalculatedValue(totalImpressions / actualFrequency));
    const actualLTR = getWeightedValue(impressionWeights, LTR);

    processedResultArray.push({
      [BeeswaxReportProperties.DAY_OF_WEEK]: key,
      Impressions: totalImpressions,
      Reach: actualReach,
      Frequency: actualFrequency,
      CTR: getCalculatedValue(Clicks / totalImpressions),
      Clicks: Clicks,
      [BeeswaxReportProperties.IP_CONVERSIONS]: value[BeeswaxReportProperties.IP_CONVERSIONS],
      [BeeswaxReportProperties.VCR]: getCalculatedValue(
        value[BeeswaxReportProperties.VIDEO_COMPLETES] / value[BeeswaxReportProperties.VIDEO_PLAYS],
      ),
      LTR: actualLTR,
    });
  }

  return processedResultArray;
};
